<template>
    <div class="stretch-area">
        <div
            v-if="activity"
            class="activity-card alert"
            :class="{
                'alert-secondary position-relative':
                    activity.generalStatus == 'completed',
                'alert-danger': activity.generalStatus == 'overdue',
                'alert-light': activity.generalStatus == 'active',
                'border border-dark':
                    activity.generalStatus == 'active' &&
                    treatmentBoardView != 'patient'
            }"
            role="alert"
            :style="{
                cursor:
                    !prepareActivityDetails &&
                    treatmentBoardView != 'patient' &&
                    !_isTvView
                        ? 'pointer'
                        : null,
                'border-right-color':
                    treatmentBoardView != 'patient' ? 'lightgray' : null,
                'border-right-width':
                    treatmentBoardView != 'patient' ? '1.5px' : null
            }"
            @click="
                !prepareActivityDetails &&
                treatmentBoardView != 'patient' &&
                !_isTvView
                    ? openModal(activity)
                    : null
            "
        >
            <template v-if="treatmentBoardView == 'patient'">
                <div class="activity-info">
                    <!-- Activity Info Section -->
                    <item-name
                        v-if="activityType == TREATMENT_TYPE_STR.MEDICAL"
                        class="padding-text-first activity-text activity-text-ext"
                        :item="selectedActivity"
                        v-b-tooltip.hover.right="selectedActivity.name"
                    />
                    <span
                        v-else
                        class="padding-text-first activity-text activity-text-ext"
                        v-b-tooltip.hover.right="selectedActivity.name"
                    >
                        <b>{{ selectedActivity.name }}</b>
                    </span>

                    <!-- Buttons Section -->
                    <div class="activity-info-buttons">
                        <div
                            v-if="
                                treatmentStatus.status_id >
                                TREATMENT_STATUS.ADMITTED
                            "
                            class="btn-group dropright"
                        >
                            <button
                                v-if="activity.generalStatus != 'completed'"
                                type="button"
                                class="btn btn-secondary btn-sm"
                                v-b-tooltip.hover.top
                                title="Complete the activity"
                                @click="openModal(activity)"
                            >
                                <i class="fas fa-check"></i>
                            </button>

                            <button
                                ref="dropdown"
                                type="button"
                                class="btn btn-secondary dropdown-toggle no-caret btn-sm"
                                data-toggle="dropdown"
                                @click="toggleDropdown"
                            >
                                <i class="fas fa-ellipsis-v"></i>
                            </button>
                            <!-- Dropdown Menu -->
                            <div
                                class="dropdown-menu"
                                aria-labelledby="dropdownMenuButton"
                                :class="{
                                    show: isDropdownVisible
                                }"
                            >
                                <template
                                    v-for="(item, index) in dropdownItems"
                                >
                                    <a
                                        :key="index"
                                        class="dropdown-item cursor-pointer"
                                        @click="item.modal"
                                        v-if="item.visible"
                                    >
                                        {{ item.text }}
                                    </a>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="activity-status padding-text-first">
                    <template v-if="activity.generalStatus == 'completed'">
                        <span
                            v-if="referTime.forgoState"
                            class="activity-text activity-text-ext"
                        >
                            <b>{{ referTime.forgoState }}</b>
                        </span>
                        <span v-else class="d-flex">
                            <span class="activity-text activity-text-ext mr-2"
                                ><b>Completed:</b> {{ referTime.date }}
                                {{ referTime.time }}
                                {{ referTime.meridiem }}</span
                            >
                            <span
                                class="custom-checkbox disabled unset-custom-checkbox"
                            >
                                <i class="fas fa-check"></i>
                            </span>
                        </span>
                        <span class="activity-text activity-text-ext"
                            ><b>Due:</b> {{ dueTime.date }} {{ dueTime.time }}
                            {{ dueTime.meridiem }}</span
                        >
                    </template>
                    <span v-else class="activity-text activity-text-ext"
                        ><b>Due:</b> {{ referTime.date }} {{ referTime.time }}
                        {{ referTime.meridiem }}</span
                    >
                    <template v-if="activityType == TREATMENT_TYPE_STR.MEDICAL">
                        <span class="activity-text activity-text-ext"
                            ><b>Quantity:</b>
                            {{
                                selectedActivity.route
                                    ? selectedActivity.quantity
                                    : ""
                            }}</span
                        >
                        <span
                            v-if="selectedActivity.route"
                            class="activity-text activity-text-ext"
                            ><b>Route:</b>
                            {{ selectedActivity.route.value }}</span
                        >
                        <span
                            v-if="selectedActivity.location"
                            class="activity-text activity-text-ext"
                            ><b>Location:</b>
                            {{ selectedActivity.location.value }}</span
                        >
                    </template>
                    <span
                        class="activity-text activity-text-ext"
                        v-b-tooltip.hover.right="selectedActivity.note"
                        ><b>Note:</b> {{ selectedActivity.note }}</span
                    >
                </div>
            </template>
            <template v-else>
                <span
                    v-if="referTime.forgoState"
                    class="padding-text-first activity-text"
                >
                    {{ referTime.forgoState }}
                </span>
                <span v-else class="padding-text-first activity-text">
                    {{ referTime.time }} {{ referTime.meridiem }}
                </span>
                <span class="activity-card-date activity-text">
                    {{ referTime.date }}
                </span>
                <span class="padding-text-first activity-text-container">
                    <span
                        v-if="!prepareActivityDetails"
                        class="activity-text"
                        >{{ selectedActivity.name }}</span
                    >
                    <span v-else
                        ><div class="loading-skeleton mb-1"></div>
                        <div class="loading-skeleton" style="width: 75px;"></div
                    ></span>
                </span>
                <!-- Checked and disabled custom checkbox -->
                <div
                    v-if="
                        treatmentBoardView != 'patient' &&
                        activity.generalStatus === 'completed' &&
                        !referTime.forgoState
                    "
                    class="custom-checkbox disabled"
                >
                    <i class="fas fa-check"></i>
                </div>
            </template>
        </div>
    </div>
</template>
<script>
import ScheduleHelper from "../helper";
import { isEmpty } from "lodash";
import CITEMTYPES from "@/constants/item-types";
import ItemName from "@/components/commons/item-name";
import TreatmentActivityMixin from "@/mixins/treatment-activity-details";

export default {
    name: "PatientTreatmentDetailsCard",
    mixins: [ScheduleHelper, TreatmentActivityMixin],
    components: { ItemName },
    props: {
        treatmentBoardView: {
            type: String,
            default: "timeline"
        },
        treatment: {
            type: Object,
            default() {
                {
                    return {};
                }
            }
        },
        activity: {
            type: Object,
            default() {
                {
                    return {};
                }
            }
        },
        prepareDateTime: {
            type: Function
        },
        dialogs: {
            type: Object,
            default() {
                return {};
            }
        },
        activityType: {
            type: Number,
            default: null
        },
        labelOptions: {
            type: Array,
            default() {
                return [];
            }
        },
        routeOptions: {
            type: Array,
            default() {
                return [];
            }
        },
        locationOptions: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            isChecked: true,
            referTime: {
                time: null,
                timeSimplify: null,
                hour: null,
                minute: null,
                meridiem: null,
                date: null,
                current: null,
                reference: null
            },
            dueTime: {
                time: null,
                timeSimplify: null,
                hour: null,
                minute: null,
                meridiem: null,
                date: null,
                current: null,
                reference: null
            },
            selectedActivity: { name: null, encodedId: null, note: null },
            isDropdownVisible: false,
            dropdownItems: []
        };
    },
    computed: {
        treatmentStatus() {
            return this.treatment.treatment_status.find(
                item => item.isactive === true
            );
        }
    },
    watch: {
        activity: {
            handler(params) {
                // Convert the Unix timestamp to a DateTime object
                if (isEmpty(params)) return;
                let referTime = this._toDateTime(params.referTime);
                this.referTime = this.prepareDateTime(referTime);

                // use by complete, deactivate and incomplete activity status
                let dueTime = this._toDateTime(params.dueCalculated.time);
                this.dueTime = this.prepareDateTime(dueTime);

                if (
                    params.generalStatus == "completed" &&
                    !params.complete_at
                ) {
                    if (
                        params.status ==
                        this.TREATMENT_ACTIVITY_STATUS.DEACTIVATED
                    ) {
                        this.referTime.forgoState = "Deactivated";
                    } else {
                        this.referTime.forgoState = "Incomplete";
                    }
                }

                this.getActivityText(params);
                this.prepareButtons();
            },
            immediate: true // Trigger the handler on initial load
        }
    },
    methods: {
        getActivityText(oriActivity) {
            // Determine the activity text based on the treatment type
            let selectedActivity = null;
            let activity = { ...oriActivity };
            switch (activity.treatment_activity_type_id) {
                case this.TREATMENT_TYPE_STR.MEDICAL: {
                    activity =
                        activity.medication.length > 0
                            ? activity.medication[0]
                            : null;
                    let encodedId = activity
                        ? activity?.item?.encoded_id || activity.encoded_id
                        : null;
                    let name = activity
                        ? activity?.item?.name || activity.name
                        : null;

                    selectedActivity = {
                        name: name,
                        encodedId: encodedId,
                        note: oriActivity?.note,
                        route: null,
                        location: null,
                        quantity: activity?.quantity
                    };
                    if (activity?.item?.type != CITEMTYPES.TYPES.TYPE_LAB) {
                        selectedActivity.route = this.routeOptions.find(
                            option => option.id === activity.route_id
                        );
                        selectedActivity.location = this.locationOptions.find(
                            option => option.id === activity.location_id
                        );
                    }
                    break;
                }
                case this.TREATMENT_TYPE_STR.VITAL: {
                    selectedActivity = {
                        name: activity.vitals
                            .map(vital => vital.master_vital.vital)
                            .join(", "),
                        note: oriActivity?.note
                    };
                    break;
                }
                case this.TREATMENT_TYPE_STR.OTHER: {
                    if (
                        activity.other_task[0] &&
                        this.labelOptions.length > 0
                    ) {
                        activity = activity.other_task[0];
                        let labelId = activity.label_id ? activity.label_id : 1;
                        let label = this.labelOptions.find(
                            option => option.value === labelId
                        );
                        let name = label.text;
                        if (
                            label.text == "Miscellaneous" &&
                            this.treatmentBoardView != "patient"
                        ) {
                            name = `Misc: ${
                                activity.task == ""
                                    ? "No details"
                                    : activity.task
                            }`;
                        }

                        selectedActivity = {
                            name: name,
                            note: oriActivity?.note
                        };
                    }
                    break;
                }
            }
            this.selectedActivity = selectedActivity;
        },
        activityAction(action) {
            let data = {
                treatment: this.treatment,
                activity: this.activity
            };
            switch (action) {
                case "edit":
                case "reactivate":
                    this.edit(data);
                    break;
                case "duplicate":
                    this.duplicate(data);
                    break;
                case "deactivate":
                case "delete":
                    this.deleteModal(data);
                    break;
                case "history":
                    this.activityHistory(data);
                    break;
            }
        },
        toggleDropdown() {
            this.isDropdownVisible = !this.isDropdownVisible;
            if (this.isDropdownVisible) {
                document.addEventListener("click", this.handleClickOutside);
            } else {
                document.removeEventListener("click", this.handleClickOutside);
            }
        },
        handleClickOutside(event) {
            if (!this.$refs.dropdown.contains(event.target)) {
                setTimeout(() => {
                    this.isDropdownVisible = false;
                }, 0);
                document.removeEventListener("click", this.handleClickOutside);
            }
        },
        prepareButtons() {
            this.dropdownItems = [
                {
                    text: "Reactivate",
                    modal: () => this.activityAction("reactivate"),
                    visible:
                        this._hasAccess("schedule.treatmentboard.update") &&
                        this.activity.status ===
                            this.TREATMENT_ACTIVITY_STATUS.DEACTIVATED
                },
                {
                    text: "Edit",
                    modal: () => this.activityAction("edit"),
                    visible:
                        this._hasAccess("schedule.treatmentboard.update") &&
                        this.activity.status !==
                            this.TREATMENT_ACTIVITY_STATUS.DEACTIVATED
                },
                {
                    text: "Duplicate",
                    modal: () => this.activityAction("duplicate"),
                    visible:
                        this._hasAccess("schedule.treatmentboard.create") &&
                        this.activity.status !==
                            this.TREATMENT_ACTIVITY_STATUS.DEACTIVATED
                },
                {
                    text: "Deactivate",
                    modal: () => this.activityAction("deactivate"),
                    visible:
                        this._hasAccess("schedule.treatmentboard.delete") &&
                        this.activity.status ===
                            this.TREATMENT_ACTIVITY_STATUS.PENDING
                },
                {
                    text: "Delete",
                    modal: () => this.activityAction("delete"),
                    visible:
                        this._hasAccess("schedule.treatmentboard.delete") &&
                        this.activity.status ===
                            this.TREATMENT_ACTIVITY_STATUS.STARTED
                },
                {
                    text: "History",
                    modal: () => this.activityAction("history"),
                    visible: true
                }
            ];
        }
    }
};
</script>
<style scoped>
.activity-card {
    display: flex;
    flex-direction: column;
    align-items: start;
    padding: 0;
    margin-bottom: 0;
    height: 100%;
    border-radius: 0px;
}
.activity-info {
    display: flex; /* d-flex */
    flex-direction: row; /* flex-row */
    width: -webkit-fill-available;
}
.activity-info-buttons {
    display: flex; /* d-flex */
    align-items: flex-start; /* align-items-start */
    padding-right: 0.5rem; /* pr-2 */
    padding-top: 0.25rem; /* pt-1 */
    padding-bottom: 0.25rem; /* pb-1 */
    margin-left: auto; /* ml-auto */
}
.activity-status {
    display: flex; /* d-flex */
    flex-direction: column; /* flex-column */
    padding-bottom: 0.5rem; /* pb-1 */
    width: -webkit-fill-available;
}
.stretch-area {
    width: -webkit-fill-available;
}
.activity-text-container {
    line-height: normal;
    max-height: 100px;
    padding-bottom: 0.5rem; /* pb-2 */
    margin: auto; /* m-auto */
    text-align: center; /* text-center */

    /* Show scrollbar verticallly only */
    overflow-x: scroll;
    scrollbar-color: rgba(0, 0, 0, 0.3) transparent;
}
.activity-card-date {
    padding-left: 0.5rem; /* pl-2 */
    padding-right: 0.5rem; /* pr-2 */
    padding-bottom: 0.25rem; /* pb-1 */
    font-size: small !important;
}
.activity-text {
    font-size: large;
    font-weight: lighter;
    color: black;
}
.activity-text-ext {
    font-size: unset;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.loading-skeleton {
    background: #e0e0e0;
    background: linear-gradient(
        to right,
        rgba(230, 230, 230, 1) 8%,
        rgba(238, 238, 238, 1) 30%,
        rgba(230, 230, 230, 1) 33%
    );
    background-size: 200% 100%;
    width: 125px;
    height: 35px;
    border-radius: 3px;
    animation: loading 10s infinite linear; /* Smooth animation */
}
/* Base styles for the custom checkbox */
.custom-checkbox {
    width: 16px; /* Size of the checkbox */
    background-color: #fff; /* Default background color */
    border: 2px solid #ccc; /* Default border color */
    border-radius: 2px; /* Optional: Rounded corners */
    position: absolute;
    top: -1px;
    right: 0;
    cursor: pointer; /* Pointer cursor for interactive checkboxes */
    text-align: center;
    line-height: 10px; /* Center the icon */
}

/* Disabled state */
.custom-checkbox.disabled {
    background-color: gray; /* Darker gray for disabled state */
    border-color: gray; /* Darker border for disabled state */
    cursor: pointer; /* Show a disabled cursor */
}

/* Icon styles */
.custom-checkbox i {
    font-size: 10px; /* Adjust icon size */
    color: white; /* Inherit text color from the parent */
}
.unset-custom-checkbox {
    position: unset;
    padding: 2px;
    width: unset;
}
/* Increased specificity and added !important to ensure the caret is hidden */
::v-deep button.no-caret::after {
    display: none !important;
}

.padding-text-first {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    padding-top: 0.25rem;
}
</style>
